import {
  TeamDomainQueryModelSchema,
  TeamProfileDomainQueryModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { TeamQueryShapeSchema } from '../types.ts'
import { TeamAclSchema } from './get-team.models.ts'

export const GetTeamWithProfileInputSchema = TeamDomainQueryModelSchema.pick({
  teamId: true,
})

export type GetTeamWithProfileInput = ZodInfer<
  typeof GetTeamWithProfileInputSchema
>

export const GetTeamWithProfileProfileOutputSchema =
  TeamProfileDomainQueryModelSchema.omit({
    teamId: true,
    teamProfileId: true,
  }).optional()

export const GetTeamWithProfileOutputSchema = TeamQueryShapeSchema.extend({
  acl: TeamAclSchema,
  profile: GetTeamWithProfileProfileOutputSchema,
}).transform(({ profile, ...team }) => {
  return {
    ...team,
    // Team Profiles don't exist until saved for the first time. Returning an empty object acts as a profile placeholder.
    profile: { ...(profile ?? {}) },
  }
})

export type GetTeamWithProfileOutput = ZodInfer<
  typeof GetTeamWithProfileOutputSchema
>
